module.exports = __webpack_public_path__ + "img/glsl-js.091f9b9d.svg";